var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.228255mm",
    height: "12.670173mm",
    viewBox: "0 0 11.228255 12.670173",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-400.05647,-219.70445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7",
    transform: "translate(112.46401,50.513412)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.451826,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 249.49329,172.19832 -0.39125,2.67939 1.6518,1.19644 2.04917,-0.38523 0.88785,-1.93556 -0.83264,-1.79707 -1.80688,-0.76141 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2-3-4",
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.6025,
      paintOrder: "stroke fill markers"
    },
    d: "m 250.0695,170.93837 -0.84001,0.62335 -0.73542,1.97456 0.26651,1.59973 1.72553,1.42411 1.90484,-0.31134 0.8033,1.15076 0.55233,1.00255 0.80454,-0.0748 0.55731,-0.96704 -1.629,-1.74918 0.37548,-0.80765 0.30761,-1.72549 -0.78146,-1.18627 -1.50197,-0.95334 z m 1.33262,0.784 1.22359,0.56166 0.50253,1.32637 -0.46889,1.48764 -1.5873,0.48013 -1.05796,-0.63458 -0.45893,-1.07167 0.47514,-1.58228 z m -0.50068,0.87052 -0.009,0.72357 -0.69432,0.005 0.005,0.63767 0.79397,0.0436 -0.005,0.75469 0.73853,-0.005 -0.0543,-0.76779 0.72545,0.0179 -0.0678,-0.65695 -0.66693,0.0286 -0.029,-0.77898 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.6fb6b5e8fb6f8f3329ce08760acf6c8b.svg";
export { ForwardRef as ReactComponent };